import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { faBolt, faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

import { ProcessingOperation } from '../../services/processings.service';
import { Configuration } from '../../services/configurations.service';

@Component({
  selector: 'app-modal-test-operation',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, TranslateModule, NgSelectModule],
  templateUrl: './modal-test-operation.component.html',
  styleUrls: ['./modal-test-operation.component.scss'],
})
export class ModalTestOperationComponent implements OnChanges {
  icons = { faBolt, faSpinner, faTimes };

  @Input() show = false;
  @Input() operation: ProcessingOperation | null = null;
  @Input() llmConfigs: Configuration[] = [];
  @Input() llmConfigId: string | null = null;
  @Input() runner?: () => Promise<{ output?: any; error?: string }>;

  @Output() llmConfigIdChange = new EventEmitter<string | null>();
  @Output() close = new EventEmitter<void>();

  loading = false;
  output?: string;
  error?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show'] && this.show && !changes['show'].previousValue) {
      this.output = undefined;
      this.error = undefined;
      this.run();
    }
  }

  get isAi(): boolean {
    return this.operation?.type === 'ai';
  }

  onLlmChange(value: string | null): void {
    this.llmConfigId = value;
    this.llmConfigIdChange.emit(value);
  }

  async run(): Promise<void> {
    if (!this.runner || this.loading) return;
    this.loading = true;
    this.output = undefined;
    this.error = undefined;

    const result = await this.runner();

    this.output = result.output !== undefined ? JSON.stringify(result.output, null, 2) : undefined;
    this.error = result.error;
    this.loading = false;
  }

  onClose(): void {
    this.close.emit();
  }

  onOverlayClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close.emit();
    }
  }
}
